export default __webpack_public_path__ + "static/media/entete.18ce32b9.png";